document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector(
    '.recovery-bundle-section'
  );

  if (!section) return;

  const button = section.querySelector(
    '[data-add-to-cart]'
  );

  const errorElement = section.querySelector(
    '[data-cart-error]'
  );

  if (!button) return;

  const variantId = button.dataset.variantId;

  if (!variantId) {
    console.error('Recovery Bundle: Variant ID not found.');
    return;
  }

  button.addEventListener('click', async function (event) {
    event.preventDefault();

    if (button.disabled) return;

    button.disabled = true;
    button.classList.add('is-loading');

    if (errorElement) {
      errorElement.hidden = true;
      errorElement.textContent = '';
    }

    try {
      /*
       * Clear any existing cart contents first so the
       * checkout contains only this offer.
       */
      const clearResponse = await fetch(
        window.Shopify.routes.root + 'cart/clear.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }
      );

      if (!clearResponse.ok) {
        throw new Error('Unable to clear cart.');
      }

      const response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]
          })
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          'Unable to add product to cart.'
        );
      }

      /*
       * Product successfully added.
       * Redirect directly to Shopify checkout,
       * skipping the cart page.
       */
      window.location.href =
        window.Shopify.routes.root + 'checkout';

    } catch (error) {
      console.error(
        'Recovery Bundle Cart Error:',
        error
      );

      if (errorElement) {
        errorElement.textContent =
          error.message ||
          'Something went wrong. Please try again.';

        errorElement.hidden = false;
      }

      button.disabled = false;
      button.classList.remove('is-loading');
    }
  });
});
